import { QueryClient } from "react-query";

// Status codes worth retrying (transient server errors)
// 500 is NOT included - it indicates a bug, not a transient failure
export const RETRYABLE_STATUS_CODES = new Set([
  502, // Bad Gateway - upstream may recover
  503, // Service Unavailable - temporary overload
  504, // Gateway Timeout - upstream was slow
]);

// Retries are disabled globally by default.
// Individual queries can opt-in to retries by passing retry config to useApiQuery.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false, // Opt-in only - individual queries can override
    },
  },
});
